import { url } from './config';

export async function ydymGetText(path: string): Promise<string> {
  try {
    const res = await fetch(url(path), { method: 'GET', credentials: 'omit' });
    return res.text();
  } catch {
    return '';
  }
}

export async function ydymGetJson<T = any>(path: string): Promise<T | undefined> {
  try {
    const res = await fetch(url(path), {
      method: 'GET',
      credentials: 'omit',
      headers: { Accept: 'application/json' },
    });
    const text = await res.text();
    try {
      return JSON.parse(text) as T;
    } catch {
      return undefined;
    }
  } catch {
    return undefined;
  }
}

export async function ydymPostJson(path: string, body: Record<string, unknown>): Promise<any> {
  try {
    const res = await fetch(url(path), {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      body: JSON.stringify(body),
    });
    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  } catch {
    return undefined;
  }
}

export async function ydymPostForm(path: string, fields: Record<string, string>): Promise<any> {
  try {
    const body = new URLSearchParams(fields);
    const res = await fetch(url(path), {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
      body: body.toString(),
    });
    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  } catch {
    return undefined;
  }
}

export async function ydymUploadFile(
  path: string,
  fields: Record<string, string>,
  file: Blob,
  fileName: string,
  fileField = 'file',
  mime = 'application/octet-stream',
): Promise<any> {
  const form = new FormData();
  Object.entries(fields).forEach(([k, v]) => form.append(k, v));
  form.append(fileField, file, fileName);
  try {
    const res = await fetch(url(path), {
      method: 'POST',
      credentials: 'omit',
      body: form,
    });
    void mime;
    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  } catch {
    return undefined;
  }
}

export function unwrapData<T = any>(raw: any): T | undefined {
  if (!raw || typeof raw !== 'object') return undefined;
  if (raw.data !== undefined) return raw.data as T;
  return raw as T;
}
